import { MobileHeader } from '../../components/Header';
import { useLocation } from 'react-router-dom';
import { ReactNode, useEffect } from 'react';

import { ReactComponent as BuyIcon } from 'src/assets/icons/bonus-game/quests/buy-icon.svg';
import { ReactComponent as HaqabiLogo } from 'src/assets/icons/bonus-game/quests/haqabi-logo.svg';
import { ReactComponent as InviteIcon } from 'src/assets/icons/bonus-game/quests/invite-icon.svg';
import { ReactComponent as StakingIcon } from 'src/assets/icons/bonus-game/quests/try-staking.svg';
import { ReactComponent as TrySwapsIcon } from 'src/assets/icons/bonus-game/quests/try-swaps.svg';
import { ReactComponent as TryDappsIcon } from 'src/assets/icons/bonus-game/quests/try-dapps.svg';
import { ReactComponent as DepositIcon } from 'src/assets/icons/bonus-game/quests/deposit.svg';
import { ReactComponent as ShareIcon } from 'src/assets/icons/bonus-game/share-icon.svg';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';
import { Button } from 'src/pages/BonusGame/components/Button';
import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import {
  Description,
  RewardAmount,
  RewardText,
  RewardWrapper,
  StartQuestText,
  Title,
} from './styled';
import { Promocode } from '../../components/Promocode';
import { PageWrapper } from '../../ui/common';
import { bonusGameApi } from 'src/api/bonus-game';

const iconSize = { width: '56px', height: '56px' };

const iconsMap: Record<string, ReactNode> = {
  haqabiIcon: <HaqabiLogo {...iconSize} />,
  inviteIcon: <InviteIcon {...iconSize} />,
  stakingIcon: <StakingIcon {...iconSize} />,
  buyIcon: <BuyIcon {...iconSize} />,
  dappsIcon: <TryDappsIcon {...iconSize} />,
  swapIcon: <TrySwapsIcon {...iconSize} />,
  depositIcon: <DepositIcon {...iconSize} />,
};

export const QuestDetailPage = () => {
  const location = useLocation();
  const { iconName, title, description, reward, promocode, actionType } =
    location.state || {};

  const handleAction = () => {
    switch (actionType) {
      case 'navigate_haqabi_webpage':
        bonusGameApi.claimQuestReward({ questType: 'VISIT_HAQABI_WEBSITE' });

        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: 'navigate-browser',
            data: 'https://www.haqabi.com',
          }),
        );
        break;

      case 'navigate_buy':
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({ type: 'navigate', data: { screen: 'Buy' } }),
        );
        break;
      case 'navigate_dapps':
        bonusGameApi.claimQuestReward({ questType: 'TRY_DAPPS' });
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: 'navigate',
            data: { screen: 'Hub', nestedScreen: 'DappsMain' },
          }),
        );
        break;
      case 'navigate_swaps':
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({ type: 'navigate', data: { screen: 'Swap' } }),
        );
        break;
      case 'navigate_staking':
        bonusGameApi.claimQuestReward({ questType: 'TRY_STAKING' });
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({ type: 'navigate', data: { screen: 'Earn' } }),
        );
        break;
      case 'invite_friend':
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: 'share-popup',
            data: {
              message: `Join me on Haqabi Tree game using my promo code ${promocode}`,
            },
          }),
        );
        break;
      case 'deposit':
        (window as any).ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: 'navigate',
            data: {
              screen: 'Receive',
            },
          }),
        );
        break;
    }
  };

  return (
    <PageWrapper>
      <MobileHeader title="Quests" />
      <VerticalView style={{ flex: 1, gap: '24px' }}>
        {iconsMap[iconName]}
        <VerticalView>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </VerticalView>
        {promocode && <Promocode promoCode={promocode} />}
        <RewardWrapper>
          <VerticalView>
            <RewardText>Reward</RewardText>
            <HorizontalView style={{ justifyContent: 'center' }}>
              <CoinIcon width={16} height={16} />
              <RewardAmount>{reward}</RewardAmount>
            </HorizontalView>
          </VerticalView>
        </RewardWrapper>
      </VerticalView>

      <Button
        onClick={handleAction}
        style={{ width: '100%', background: 'var(--color-primary-4)' }}
        title={
          <HorizontalView style={{ gap: '8px' }}>
            <StartQuestText>Start Quest</StartQuestText>{' '}
            <ShareIcon width={16} height={16} />
          </HorizontalView>
        }
      />
    </PageWrapper>
  );
};
